import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InvoicesService } from '../../services/invoices.service';
import { environment } from '../../../environments/environment';

interface IItems {
  itemCAAmountInTransactionCurrency: string
  itemCADocumentNumber: string
  itemCAMainTransactionName: string
  itemNo: string
  itemQuantity: string
  itemTransactionCurrency: string
  itemType: string
  itemTypeName: string
  itemUnitOfMeasureName: string
  taxAmountInTransCurrency: string
  checked: boolean
}

export interface IInvoiceDetails {
  InvoiceNumber: string
  CustomerName: string,
  BusinessPartner: string
  InvoiceDate: string
  DueDate: string
  InvoiceAmount: string,
  OutstandingBalance: string,
  ChargeDate: string
  Quantity: string,
  Amount: string,
  Tax: string,
  Total: string,
  ProductType: string
  ProductSubType: string,
  ServicePeriod: string,
  ChargeName: string,
  Discount: string
}

interface MyMap {
  string: Array<IItems>;
}

@Component({
  selector: 'app-tsa-invoice-details',
  templateUrl: './tsa-invoice-details.component.html',
  styleUrls: ['./tsa-invoice-details.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class TSAInvoiceDetailsComponent implements OnInit {
  item: any;
  items: Array<IItems> = new Array<IItems>();
  invoiceId: any;
  invoice: any;
  invoiceItemData: IInvoiceDetails[] = [];
  invoiceDetailsReceived = false;
  totalInvoiceAmount: number = 0;
  top: any = 50;
  skip: any = 0;
  isDisputeCreateEnabled: boolean = environment.DisputeCreateEnableFlag;
  permissions: String[] = environment.billingProps.permissions;

  constructor(private route: ActivatedRoute, private invoicesService: InvoicesService, private router: Router) {
    this.invoice = history.state.invoice;
    this.getHistoricalInvoiceDetails(this.invoice);
  }

  ngOnInit(): void { }

  getHistoricalInvoiceDetails(invoice: any) {
    this.invoiceDetailsReceived = false;
    this.invoicesService.getInvoiceDetail(invoice.invoice_id, invoice.bpNo, invoice.caContract, true, this.top, this.skip, true).subscribe((res: any) => {
      this.invoiceItemData = res;
      this.invoiceDetailsReceived = true;
      this.calculateTotalAmount();
    });
  }

  selectedItem(item: any) {
    this.item = item;
    this.items.forEach((ele) => {
      if (ele.itemNo != item.itemNo) {
        ele.checked = false;
      }
    })
    if (!item.checked || !item.checked) {
      item.checked = true;
    } else {
      item.checked = false;
      this.item = null;
    }

  }

  transformInvoiceDate(dateString: string): Date {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(4, 6);
    const day = dateString.slice(6, 8);
    return new Date(`${year}-${month}-${day}`);
  }

  calculateTotalAmount() {
    this.totalInvoiceAmount = this.invoiceItemData.reduce((total, item) => {
      return total + Number(item.Amount);
    }, 0);
  }

  formatServicePeriod(servicePeriod: any) {
    // Split the service period string into start and end dates
    const [startDateStr, endDateStr] = servicePeriod.split(' to ');

    // Function to format the date from 'YYYYMMDD' to 'MM/DD/YYYY'
    const formatDate = (dateStr: string) => {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${month}/${day}/${year}`;
    };
    // Format both start and end dates
    const formattedStartDate = startDateStr && formatDate(startDateStr);
    const formattedEndDate = endDateStr && formatDate(endDateStr);

    // Return the formatted service period
    return `${formattedStartDate} to ${formattedEndDate}`;
  }

  downloadCSV() {
    let jsonData = this.invoiceItemData;
    let csvContent = "";

    function formatHeader(header: any) {
      return header.replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (char: any) => char.toUpperCase());
    }

    if (jsonData.length === 0) return;

    const headers = Object.keys(jsonData[0]);
    const formattedHeaders = headers.map(formatHeader);
    csvContent += formattedHeaders.join(",") + "\n";

    jsonData.forEach((item: any) => {
      const row = headers.map(header => item[header] ?? "");
      csvContent += row.join(",") + "\n";
    });

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${this.invoice.invoice_id}-charges.csv`;;
    link.click();
  }

  disputeCreation(){
    if (this.isDisputeCreateEnabled && this.permissions.includes('BI-CBT')) {
      localStorage.setItem('dispute-type', 'invoice-level-dispute')
      localStorage.setItem('selected-invoice-to-dispute', JSON.stringify(this.invoice))
      localStorage.setItem('selected-type-to-dispute', 'invoice')
      this.router.navigate(['/invoices/create-dispute'], { state: { invoice: this.invoice, type: 'invoice' } });
    }
  }
}